<script>
    export let x; 
    export let y;
    export let fill;
</script>

<g>
    <circle class="tooltip-point" style="fill: {fill};" cx={x} cy={y} r="4" />
</g>

<style>

</style>

<!-- https://svelte.dev/repl/80aee1d6405b4e6aa588f8f3fc0fdad2?version=3.32.3 -->